export const staticBase = process.env.VUE_APP_STATIC_URL;
export const rootUrl = process.env.VUE_APP_ROOT_URL;
export const apiBase = process.env.VUE_APP_API_URL;
